module.exports = __webpack_public_path__ + "img/com_reg_1.fb5f78e2.png";